import makeActionCreator from './makeActionCreator';
import {
  ADD_NEW_SELF_LAUNCH,
  ADD_NEW_SELF_LAUNCH_DONE,
  ADD_NEW_SELF_LAUNCH_ERROR,
  ADD_NEW_SELF_LAUNCH_LOADING,
  ADD_NEW_SELF_LAUNCH_SUCCESS,
  FETCH_SELF_LAUNCH_LIST,
  FETCH_SELF_LAUNCH_LIST_DONE,
  FETCH_SELF_LAUNCH_LIST_ERROR,
  FETCH_SELF_LAUNCH_LIST_LOADING,
  FETCH_SELF_LAUNCH_LIST_SUCCESS,
  REMOVE_SELF_LAUNCH,
  REMOVE_SELF_LAUNCH_DONE,
  REMOVE_SELF_LAUNCH_ERROR,
  REMOVE_SELF_LAUNCH_LOADING,
  REMOVE_SELF_LAUNCH_SUCCESS
} from './actionTypes';

export const fetchSelfLaunchList = makeActionCreator(FETCH_SELF_LAUNCH_LIST, 'tenantId');
export const fetchSelfLaunchListLoading = makeActionCreator(FETCH_SELF_LAUNCH_LIST_LOADING);
export const fetchSelfLaunchListSuccess = makeActionCreator(FETCH_SELF_LAUNCH_LIST_SUCCESS,
  'heroes');
export const fetchSelfLaunchListError = makeActionCreator(FETCH_SELF_LAUNCH_LIST_ERROR, 'error');
export const fetchSelfLaunchListDone = makeActionCreator(FETCH_SELF_LAUNCH_LIST_DONE);

export const addNewSelfLaunch = makeActionCreator(ADD_NEW_SELF_LAUNCH, 'tenantId', 'emails');
export const addNewSelfLaunchLoading = makeActionCreator(ADD_NEW_SELF_LAUNCH_LOADING);
export const addNewSelfLaunchSuccess = makeActionCreator(ADD_NEW_SELF_LAUNCH_SUCCESS, 'heroes');
export const addNewSelfLaunchError = makeActionCreator(ADD_NEW_SELF_LAUNCH_ERROR, 'error');
export const addNewSelfLaunchDone = makeActionCreator(ADD_NEW_SELF_LAUNCH_DONE);

export const removeSelfLaunch = makeActionCreator(REMOVE_SELF_LAUNCH, 'tenantId', 'idOrEmail');
export const removeSelfLaunchLoading = makeActionCreator(REMOVE_SELF_LAUNCH_LOADING);
export const removeSelfLaunchSuccess = makeActionCreator(REMOVE_SELF_LAUNCH_SUCCESS, 'heroes');
export const removeSelfLaunchError = makeActionCreator(REMOVE_SELF_LAUNCH_ERROR, 'error');
export const removeSelfLaunchDone = makeActionCreator(REMOVE_SELF_LAUNCH_DONE);
